module.exports = __webpack_public_path__ + "static/media/HCMM062.3333e783.jpg";